/**
 * 화면 마스크 구분자를 제거해 DB에 저장되는 원문 길이를 계산한다.
 */
export const stripMaskCharacters = (value: any): string => {
    if (!value) return "";
    return String(value).replace(/[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"\s]/gi, "");
};

/**
 * 마스크가 있는 입력은 DB 원문 길이와 화면 표시 길이를 분리해 브라우저 maxlength를 계산한다.
 */
export const getRenderedMaxLength = (maxLength: any, mask: any): any => {
    if (typeof maxLength !== "number" || !Array.isArray(mask)) return maxLength;
    return mask.length;
};

/**
 * 마스크 문자를 제거한 실제 저장값이 DB 컬럼 길이 이내인지 확인한다.
 */
export const isWithinRawMaxLength = (value: any, maxLength: any, mask?: any): boolean => {
    if (typeof maxLength !== "number") return true;
    const rawValue = mask ? stripMaskCharacters(value) : String(value || "");
    return rawValue.length <= maxLength;
};
